export default "__VITE_ASSET__ABaOM2Vi__"